<template lang="html">
  <div data-aos="fade-in" data-aos-duration="1000">
    <h6>Historial de compras</h6>
    <hr class="c-hr" />

    <div class="box-tickets-container">
      <div class="box-tickets" v-for="(t, tInx) in 5" :key="'tInx-'+tInx">
        <div class="col col-info">
          <div class="text">05:40 AM</div>
          <div class="arrow"><i class="fa-regular fa-arrow-right-long arrow"></i></div>
          <div class="text">08:00 AM</div>
          <div class="time">2 hrs 20 mins</div>
        </div>
        <div class="col col-seats">
          <span class="seats">2 <small>ASIENTOS</small></span>
        </div>
        <div class="col col-price">
          <span>$2,490.90</span>
        </div>
        <div class="col col-button">
          <button type="button" class="btn btn-show" @click="showTickets">Ver boletos</button>
        </div>
      </div>
    </div>

    <b-modal modal-class="modal-tickets" ref="modal-tickets" size="xl" title="" hide-footer scrollable no-close-on-esc no-close-on-backdrop centered>
      <div class="box">
        <div class="box-info">
          <p class="f-w-500">
            <i class="fas fa-exclamation-circle text-danger"></i> Presenta tus boletos con codigo QR al guardia para ingresar a tu camión. No olvides presentar una identificación oficial.
          </p>
          <p class="f-w-500">
            O si lo deseas, descarga tus boletos en PDF.
          </p>
          <!-- <p class="pt-2">
            <button class="btn btn-s1"><i class="fas fa-download"></i> Descargar boletos en PDF</button>
          </p> -->
        </div>

        <div class="box-tickets">
          <!-- Boleto ida -->
          <div class="box-ticket-st-1">
            <div class="b-ticket">
              <div class="ins">
                <div class="col col-detail">
                  <div class="b-logo">
                    <img src="public/images/logo.svg">
                  </div>

                  <div class="b-ticket-info">
                    <h6 class="title-1"><strong>ADULTO</strong><span> | </span>BOLETO ÚNICO, NO TRANSFERIBLE PARA:</h6>
                    <h3 class="name">JOSE DE JESUS TORRES AMEZCUA</h3>

                    <div class="b-trip-info st-1">
                      <div class="text">Guadalajara</div>
                      <div class="arrow"><i class="fa-solid fa-arrow-right-long"></i></div>
                      <div class="text">Guasave</div>

                      <div class="col-right id-desktop">ID: 38245</div>
                    </div>

                    <div class="b-trip-info st-2">
                      <div class="text">05:40 AM</div>
                      <div class="arrow"><i class="fa-regular fa-clock"></i></div>
                      <div class="text">08:30 PM</div>

                      <div class="col-right">
                        <span class="id-mobile">ID: 38245<br /></span>
                        ASIENTO: 20
                      </div>
                    </div>

                    <h3 class="code">49843487984758758HH484HG474DEDEDEE4951</h3>
                  </div>
                </div>

                <div class="col col-qr">
                  <img src="public/images/pages/trips/qr.png">

                  <h6>FECHA</h6>
                  <h5>29/NOV/2024</h5>
                </div>
              </div>
            </div>

            <p class="pt-4 text-center">
              <button class="btn btn-s1"><i class="fas fa-download"></i> Descargar boleto en PDF</button>
            </p>
          </div>
          <!--  -->

          <!-- Boleto vuelta -->
          <div class="box-ticket-st-1">
            <div class="b-ticket">
              <div class="ins">
                <div class="col col-detail">
                  <div class="b-logo">
                    <img src="public/images/logo.svg">
                  </div>

                  <div class="b-ticket-info">
                    <h6 class="title-1"><strong>MENOR</strong><span> | </span>BOLETO ÚNICO, NO TRANSFERIBLE PARA:</h6>
                    <h3 class="name">JOSE DE JESUS TORRES AMEZCUA</h3>

                    <div class="b-trip-info st-1">
                      <div class="text">Guasave</div>
                      <div class="arrow"><i class="fa-solid fa-arrow-right-long"></i></div>
                      <div class="text">Guadalajara</div>

                      <div class="col-right id-desktop">ID: 80045</div>
                    </div>

                    <div class="b-trip-info st-2">
                      <div class="text">07:00 PM</div>
                      <div class="arrow"><i class="fa-regular fa-clock"></i></div>
                      <div class="text">10:10 PM</div>

                      <div class="col-right">
                        <span class="id-mobile">ID: 4005<br /></span>
                        ASIENTO: 3
                      </div>
                    </div>

                    <h3 class="code">13563487984d5258206H484HG474DEDEDEEXB20</h3>
                  </div>
                </div>

                <div class="col col-qr">
                  <img src="public/images/pages/trips/qr.png">

                  <h6>FECHA</h6>
                  <h5>10/DIC/2024</h5>
                </div>
              </div>
            </div>

            <p class="pt-4 text-center">
              <button class="btn btn-s1"><i class="fas fa-download"></i> Descargar boleto en PDF</button>
            </p>
          </div>
          <!--  -->
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
export default {
  data(){
    return{
     form: {
      },
    }
  },

  methods: {
    showTickets() {
      this.$refs['modal-tickets'].show();
    }
  },

  watch:{
  },

  mounted() {
  }
}
</script>
